// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../../graphql/api/index';

import { gql } from 'graphql-tag';
import { OrderedListItemFragmentDoc } from './orderedListItem.generated';
export const ComponentOrderedListFragmentDoc = gql`
    fragment componentOrderedList on ComponentOrderedList {
  __typename
  items {
    ...orderedListItem
  }
}
    ${OrderedListItemFragmentDoc}`;